﻿$.fn.dxCtrlSaisieCbStripe = function custom_dxCtrlSaisieCbStripe(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlsaisiecbstripe");
        this.instance = new cdxCtrlSaisieCbStripe(this, option);
    }
    return this;
}

window.cdxCtrlSaisieCbStripe = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var stripe = null
    var $DivButtonPayer = null
    function mConstruit() {
        container.empty()
        var containerForm = $("<form id='payment-form'/>").appendTo(container)
        var $DivInformation = $('<div id="information"></div>').appendTo(containerForm)
        var $DivPaiementElement = $('<div id="payment-element"></div>').appendTo($DivInformation)
        $DivButtonPayer = $('<button id="submit" class="buttonstripe">').appendTo(containerForm)
        $('<div class="spinner hidden" id="spinner"></div>').appendTo($DivButtonPayer)
        $('<span id="button-text">Payer</span>').appendTo($DivButtonPayer)
        $('<div id="payment-message" class="hidden"></div>').appendTo(containerForm)
        mGetPayementIntent(function (data) {
            if (typeof option.keypubliquetest != 'undefined') { stripe = Stripe(option.keypubliquetest) } //on teste une clé
            else { stripe = Stripe(data.keyapipublicstripe) }
            $("#button-text").html("Payer <b>" + (option.amount100 / 100).round().formatDisplay() + "€</b>")
            const appearance = { theme: 'night' };
            var clientSecret = data.client_secret
            elements = stripe.elements({ appearance, clientSecret });
            const paymentElement = elements.create("payment");
            paymentElement.mount("#payment-element");
            paymentElement.on('loaderror', function (event) {
                //on a une erreur
                //key api out
                if (typeof option.onLoadError != 'undefined') option.onLoadError()
            });
            document
                .querySelector("#payment-form")
                .addEventListener("submit", handleSubmit);
            window.setTimeout(function () {
                $("#payment-form").animate({ opacity: 1 }, 400, function () {
                    //$($("#payment-form").find("#Field-numberInput")[0]).focus();
                    if (typeof option.onContentReady != 'undefined') option.onContentReady()
                    //window.setTimeout(function () { $($("#payment-form").find("#Field-numberInput")[0]).focus(); },1000)
                })
            }, 1000)
        })
    }

    this.mClickButtonPayer = function () {
        $DivButtonPayer.trigger("click")
    }

    function mGetPayementIntent(funcOk) {
        option.bddCtrl.mAjaxCall({
            command: "getcbpaiementintentclient",
            id_table: option.id_table,
            id: option.id,
            id_societe: option.id_societe,
            amount100: option.amount100,
            keysecretetest: option.keysecretetest //c pour le test des clé api
        }, function (data) {
            if (typeof data.text_erreur != 'undefined') {
                //erreur sur le serveur
                if (typeof option.onErrorPaiement != 'undefined') option.onErrorPaiement(data.text_erreur)
            } else {
                funcOk(data)
            }
        },
            function () { },
            function (a, b, c, d) {
                if (typeof option.onErrorPaiement != 'undefined') option.onErrorPaiement("")
            })
    }

    async function handleSubmit(e) {
        e.preventDefault();
        jaugeDemarrage.mShow()
        stripe.confirmPayment({
            elements,
            //confirmParams: {
            //    // Make sure to change this to your payment completion page
            //    //return_url: "http://localhost:4242/checkout.html",
            //    return_url: dataCb.url_validation_reglement
            //},
            redirect: 'if_required'
        }).then(function (result) {
            if (result.error) {
                // Inform the customer that there was an error.
                jaugeDemarrage.mHide()
                mSaveError(JSON.stringify(result))
                mNotify(result.error.message, "error", 6000)
                //if (result.error.type === "card_error" || result.error.type === "validation_error") {
                //    showMessage(result.error.message, "red");
                //} else {
                //    showMessage("Une erreur inattendue s'est produite (" + result.error.type + ").", "red");
                //}
                //mSaveError("dataCb.url_validation_reglement", "", result)
            } else {
                debugger
                option.bddCtrl.mAjaxCall({
                    command: "validpaiementcbinternetstripe",
                    id_table: option.id_table,
                    id: option.id,
                    paiement_intent: result.paymentIntent.id,
                    amount100: option.amount100
                }, function (data) {
                    option.onValidePaiement(option.amount100, result.paymentIntent)
                },
                    function () {
                        inCallConfirmCheckOut = false
                        jaugeDemarrage.mHide()
                    },
                    function (a, b, c, d) {
                        mSaveError(JSON.stringify(result))
                        mNotify(result.error.message, "error", 6000)
                    })
            }
        });
    }

    function mSaveError(dataError) {
        try {
            option.bddCtrl.mAjaxCall({ command: "saveerrorcb", dataError: dataError, stacktrace: mGetStackTrace() }, function (data) { })
        }
        catch (e) { }
    }

    //// Fetches the payment intent status after payment submission
    //async function checkStatus() {
    //    const clientSecret = new URLSearchParams(window.location.search).get(
    //        "payment_intent_client_secret"
    //    );

    //    if (!clientSecret) {
    //        return;
    //    }

    //    const { paymentIntent } = await stripe.retrievePaymentIntent(clientSecret);

    //    switch (paymentIntent.status) {
    //        case "succeeded":
    //            showMessage("Paiement exécuté", "green");
    //            break;
    //        case "processing":
    //            showMessage("Votre paiement est en cours de traitement.", "orange");
    //            break;
    //        case "requires_payment_method":
    //            showMessage("Votre paiement n'a pas abouti, veuillez réessayer.", "red");
    //            break;
    //        default:
    //            showMessage("Le traitement a renconté une erreur.", "red");
    //            break;
    //    }
    //}


    this.element = function () { return container }

    mConstruit();
}